import { position } from "html2canvas/dist/types/css/property-descriptors/position";
import { colors } from "../../assets/colors";
import { overflow } from "html2canvas/dist/types/css/property-descriptors/overflow";

export const container: any = {
  backgroundColor: colors.white,
  flexGrow: 1,
  marginTop: 50,
  padding: 20,
  height: "95vh",
  overflow: "auto",
};

export const avatarContainer = {
  height: 50,
  width: 50,
  borderRadius: 100,
  marginRight: 10,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
};

export const avatarContent = {
  color: colors.white,
};

export const titleContent = {
  height: 70,
  justifyContent: "start",
  alignItems: "center",
  display: "flex",
  padding: 6,
  marginTop: 10,
  width: "100%",
  paddingRight: 50,
};

export const projectSubtitle = {
  color: "gray",
  fontSize: 12,
};

export const tabContainer: any = {
  borderBottom: "1px solid #DFE0EB",
  marginLeft: 12,
  marginTop: 24,
};

export const tabText: any = {
  textTransform: "none",
  fontSize: 14,
  fontWeight: "500",
  width: 160,
  marginRight: 50,
};
